var map = {
	"./app-rosario.less": 1538,
	"./app-ucentralcolombia.less": 1551,
	"./app-uplanner.less": 1554
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1537;



//////////////////
// WEBPACK FOOTER
// ./src/assets/stylesheets ^\.\/app\-.*\.less$
// module id = 1537
// module chunks = 0